// export const API_BASE_URL = 'https://mikenoel.pythonanywhere.com/api/v1/'

export const API_BASE_URL = '/api/'
